
export function setStyles(styles) {
  return {
    type: 'SET_STYLES',
    payload: styles
  }
}